<script setup lang="ts"></script>

<template>
    <div class="close group" @click="$emit('close')">
        <svg-vue icon="x" class="h-6 w-6 transform transition-transform group-hover:rotate-180"></svg-vue>
    </div>
</template>

<style lang="scss" scoped>
.close {
    position: absolute;
    width: 64px;
    height: 64px;
    right: 0;
    top: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    @apply text-white transition-colors hover:text-purple-500;
}
</style>
